import {
  OnReady,
  SearchSymbols,
  ResolveSymbol,
  GetBars,
  SubscribeBars,
  UnsubscribeBars,
} from '../hooks/types';
import {
  IBasicDataFeed,
  OnReadyCallback,
  SearchSymbolsCallback,
  ResolveCallback,
  SymbolResolveExtension,
  ErrorCallback,
  LibrarySymbolInfo,
  ResolutionString,
  PeriodParams,
  HistoryCallback,
  SubscribeBarsCallback,
} from '../charting_library/charting_library';

const dataFeedWrapper = ({
  setOnReady,
  setSearchSymbols,
  setResolveSymbol,
  setGetBars,
  setSubscribeBars,
  setUnsubscribeBars,
}: {
  setOnReady: React.Dispatch<React.SetStateAction<OnReady | undefined>>;
  setSearchSymbols: React.Dispatch<React.SetStateAction<SearchSymbols | undefined>>;
  setResolveSymbol: React.Dispatch<React.SetStateAction<ResolveSymbol | undefined>>;
  setGetBars: React.Dispatch<React.SetStateAction<GetBars | undefined>>;
  setSubscribeBars: React.Dispatch<React.SetStateAction<SubscribeBars | undefined>>;
  setUnsubscribeBars: React.Dispatch<React.SetStateAction<UnsubscribeBars | undefined>>;
}): IBasicDataFeed => ({
  onReady: (callback: OnReadyCallback) => {
    setOnReady({
      callback,
    });
  },
  searchSymbols: (
    userInput: string,
    exchange: string,
    symbolType: string,
    onResult: SearchSymbolsCallback,
  ) => {
    setSearchSymbols({
      userInput,
      exchange,
      symbolType,
      onResult,
    });
  },
  resolveSymbol: (
    symbolName: string,
    onResolve: ResolveCallback,
    onError: ErrorCallback,
    extension?: SymbolResolveExtension,
  ) => {
    setResolveSymbol({
      symbolName,
      onResolve,
      onError,
      extension,
    });
  },
  getBars: (
    symbolInfo: LibrarySymbolInfo,
    resolution: ResolutionString,
    periodParams: PeriodParams,
    onResult: HistoryCallback,
    onError: ErrorCallback,
  ) => {
    setGetBars({
      symbolInfo,
      resolution,
      periodParams,
      onResult,
      onError,
    });
  },
  subscribeBars: (
    symbolInfo: LibrarySymbolInfo,
    resolution: ResolutionString,
    onTick: SubscribeBarsCallback,
    listenerGuid: string,
    onResetCacheNeededCallback: () => void,
  ) => {
    setSubscribeBars({
      symbolInfo,
      resolution,
      onTick,
      listenerGuid,
      onResetCacheNeededCallback,
    });
  },
  unsubscribeBars: (listenerGuid: string) => {
    setUnsubscribeBars({ listenerGuid });
  },
});

export default dataFeedWrapper;
